import React, { useEffect, useState } from "react";
import styled from "styled-components";
import OptaEvent from "./OptaEvent";
import DFBEvent from "./DFBEvent";
import { ScrollBar } from "../../Theme/Hyper";
import GraphicEvent from "./GraphicEvent";
import moment from "moment";

const Main = styled.div`
  height: 100%;
  display: flex;
  height: 16vh;
  max-height: 170px;
  position: fixed;
  bottom: ${(props) => (props.hideHeader ? "-28px" : "0px")};
`;
const ActionPanel = styled(ScrollBar)`
  display: flex;
  width: calc(100vw - 375px);
  margin-bottom: 1em;

  /* padding: 1em; */
  align-items: center;
  box-sizing: border-box;

  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  background-color: #181d25;
  overflow-x: auto;
  padding: 0.5em;
`;
const OPTA_PERIODS = [
  { value: 16, name: "Pre-match" },
  { value: 1, name: "First half" },
  { value: 10, name: "Half time" },
  { value: 2, name: "Second half" },
  { value: 3, name: "Extra time first half" },
  { value: 4, name: "Extra time second half" },
  { value: 5, name: "Penalty shootout" },
  { value: 11, name: "End of second half (before extra time)" },
  { value: 12, name: "Extra time half time" },
  { value: 13, name: "End of extra time (before penalties)" },
  { value: 14, name: "Full time" },
];

export default function Timeline({
  matchEvents,
  previewGraphic: previewGraphicMain,
  game,
  teams,
  allOptaEvents,
  timelineGraphicsStatus,
}) {
  const [graphics, setGraphics] = useState([
    {
      id: "graphic-1",
      type: "graphic",
      graphic: "MatchFacts",
      timeMin: 15,
      timeSec: 0,
      period: 1,
    },
    {
      id: "graphic-2",
      type: "graphic",
      graphic: "MatchFacts",
      timeMin: 30,
      timeSec: 0,
      period: 1,
    },
    {
      id: "graphic-3",
      type: "graphic",
      graphic: "MatchFacts",
      timeMin: 60,
      timeSec: 0,
      period: 2,
    },
    {
      id: "graphic-4",
      type: "graphic",
      graphic: "MatchFacts",
      timeMin: 75,
      timeSec: 0,
      period: 2,
    },
    // {
    //   type: "graphic",
    //   graphic: "TeamTicker",
    //   timeMin: 45,
    //   timeSec: 0,
    //   period: 2,
    //   team: "home",
    // },
    // {
    //   type: "graphic",
    //   graphic: "TeamTicker",
    //   timeMin: 45,
    //   timeSec: 0,
    //   period: 2,
    //   team: "away",
    // },
    // {
    //   type: "graphic",
    //   graphic: "ActionAreas",
    //   timeMin: 40,
    //   timeSec: 0,
    //   period: 1,
    // },
    // {
    //   type: "graphic",
    //   graphic: "ActionAreas",
    //   timeMin: 80,
    //   timeSec: 0,
    //   period: 2,
    // },
  ]);
  const [mins, setMins] = useState(0);
  const [period, setPeriod] = useState(0);

  function previewGraphic(name, options, id) {
    options.timeline_status_id = id;
    previewGraphicMain(name, options);
  }
  // let newMatchEvents = matchEvents;
  let newMatchEvents = JSON.parse(JSON.stringify(matchEvents));

  let subEvents = matchEvents?.filter((e) => e.typeId === 19);
  for (let x = 0; x < subEvents?.length; x++) {
    let sub = subEvents[x];

    let others = subEvents?.filter((e) => {
      return (
        sub.contestantId === e?.contestantId &&
        sub.timeMin - e.timeMin >= 0 &&
        sub.timeMin - e.timeMin <= 2 &&
        sub.periodId === e.periodId &&
        sub.id !== e.id &&
        sub.eventId > e.eventId
      );
    });
    if (others?.length === 1) {
      let index = newMatchEvents.findIndex((e) => e.id === sub.id);

      newMatchEvents.splice(index + 1, 0, {
        subs: others?.concat([sub]),
        ...sub,
        typeId: "DOUBLE_SUB",
      });
    } else if (others?.length === 2) {
      let index = newMatchEvents.findIndex((e) => e.id === sub.id);

      newMatchEvents.splice(index + 1, 0, {
        subs: others?.concat([sub]),
        ...sub,
        typeId: "TRIPLE_SUB",
      });
    }
  }

  useEffect(() => {
    let interval = setInterval(() => {
      let mins = document.getElementById("hyper-clock-mins")?.innerText;
      setMins(mins);
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    let periods = [...(game.live_data?.periods || [])];
    let period = periods.sort((a, b) => b.number - a.number)[0];

    setPeriod(period);
  }, [game]);

  return (
    <Main hideHeader={window.hideHeader}>
      <ActionPanel
        onWheel={(e) => {
          if (e.deltaY > 0) e.currentTarget.scrollLeft += 100;
          else e.currentTarget.scrollLeft -= 100;
        }}
      >
        {graphics
          ?.filter((item) => {
            return (
              item.timeMin === parseInt(mins) &&
              period?.number === item.period &&
              period.kick_off
            );
          })
          ?.map((item, index) => {
            return (
              <GraphicEvent
                index={index}
                previewGraphic={(name, options) => {
                  previewGraphic(name, options, game?._id + "-" + item.id);
                }}
                game={game}
                graphicEvent={item}
                allOptaEvents={allOptaEvents}
              />
            );
          })}

        {newMatchEvents &&
          newMatchEvents
            ?.toReversed()
            ?.filter((e) => e.periodId !== 5 && e?.typeId !== 18)
            ?.filter(
              (e) =>
                e?.typeId !== "live_score" ||
                (e?.typeId === "live_score" &&
                  e?.game_ID?._id !== game?._id &&
                  e?.game_ID?.competition?._id === game?.competition?._id),
            )
            .map((item, index) => {
              return (
                <>
                  {game?.opta_ID && (
                    <OptaEvent
                      index={index}
                      total={newMatchEvents.length}
                      matchEvent={item}
                      previewGraphic={(name, options) => {
                        previewGraphic(
                          name,
                          options,
                          game?._id + "-" + item.id,
                        );
                      }}
                      game={game}
                      teams={teams}
                      events={newMatchEvents}
                      timelineGraphicsStatus={timelineGraphicsStatus}
                    />
                  )}
                  {game?.dfb_ID && (
                    <DFBEvent
                      index={index}
                      total={newMatchEvents.length}
                      matchEvent={item}
                      previewGraphic={(name, options) => {
                        previewGraphic(
                          name,
                          options,
                          game?._id + "-" + item.id,
                        );
                      }}
                      game={game}
                      teams={teams}
                      events={newMatchEvents}
                      timelineGraphicsStatus={timelineGraphicsStatus}
                    />
                  )}
                </>
              );
            })}
      </ActionPanel>
    </Main>
  );
}
